import React, { useEffect } from "react";
import useFetchForm from "modules/forms/hooks/usefetchForm";
import { FormContext } from "../context/FormContext";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { EmbeddedFormOptions } from "modules/forms/embedded/EmbeddedForm";
import BootPublicForm from "modules/forms/embedded/public/BootPublicForm";
import { isFunction } from "lodash";

type EmbeddedFormOptionsWithUuid = Omit<EmbeddedFormOptions, "formId"> & {
    formUuid: string,
};

export default function BootEmbeddedForm(props: EmbeddedFormOptionsWithUuid) {
    const { formUuid, onSubmit, onError } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const { form } = useFetchForm(formUuid);

    useEffect(() => {
        if (!form) {
            return;
        }

        if (form.type == "private") {

            const token = sessionStorage.getItem("token");

            if (token) {
                if (location.pathname == `/forms/${form.uuid}/private/authenticated/custom-success`) {
                    // Do not navigate somewhere else.
                } else {
                    navigate(`/forms/${form.uuid}/private/authenticated/custom`);
                }
            } else {
                if (location.pathname == `/forms/${form.uuid}/private/authenticate-success`) {
                    // Do not navigate somewhere else.
                } else {
                    navigate(`/forms/${form.uuid}/private/authenticate`);
                }
            }
        } else {
            if (location.pathname == `/forms/${form.uuid}/public/custom-success`) {
                // Do not navigate somewhere else.
            } else {
                navigate(`/forms/${form.uuid}/public/custom`);
            }
        }
    }, [form]);

    if (!form) {
        return null;
    }

    if (!form.is_active) {
        return <p>Form is not active</p>;
    }

    return (
        <FormContext.Provider value={{
            form: form,
            onError: isFunction(onError) ? onError : () => {
                //
            },
            onSubmit: isFunction(onSubmit) ? onSubmit : () => {
                //
            },
        }}
        >
            <Routes>
                <Route path={"/forms/:formUuid/public/*"} element={<BootPublicForm/>}/>
                {/*<Route path={"/forms/:formUuid/private/*"} element={<BootPrivateForm/>}/> Not supported?*/}
            </Routes>
        </FormContext.Provider>
    );
}